import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { NavHashLink } from "react-router-hash-link";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
  const SideTopnav = ({ togglemenu, settogglemenu }) => {
  return (
    <div
      className={`h-screen transition-all fixed top-0 w-screen  flex flex-col  duration-500 ease-in-out gap-6  bg-white ${
        togglemenu ? `-left-full` : `-left-0`
      }`}
    >
      {
        <div className="w-full py-3  flex items-center justify-end ">
          <AiOutlineClose
            fill="black"
            size={"35px"}
            className="mr-2"
            onClick={() => {
              settogglemenu(true);
            }}
          />
        </div>
      }
      <div
        className={`flex flex-col  px-2 items-center gap-y-12   capitalize text-xl 
       gap-6 `}
      >
        <NavHashLink
          className=" text-2xl mt-10  "
          onClick={() => {
            settogglemenu(true);
          }}
          smooth
          to="/#home"
        >
          home
        </NavHashLink>
        <NavHashLink
          smooth
          to="/#about"
          className=" text-2xl "
          onClick={() => {
            settogglemenu(true);
          }}
        >
          about me
        </NavHashLink>
        <NavHashLink
          smooth
          to="/#Resume"
          className=" text-2xl "
          onClick={() => {
            settogglemenu(true);
          }}
        >
          Resume
        </NavHashLink>
        <NavHashLink
          smooth
          to="/#Projects"
          className=" text-2xl "
          onClick={() => {
            settogglemenu(true);
          }}
        >
          Projects
        </NavHashLink>
        <NavHashLink
          smooth
          to="/#Contact"
          className=" text-2xl "
          onClick={() => {
            settogglemenu(true);
          }}
        >
          Contact
        </NavHashLink>

        <div className="flex gap-8 mt-4">
          <a href="https://www.facebook.com/profile.php?id=100093304591176">
          <FaFacebookF fill="skyblue" size={"30px"} />
          </a>
          <a href="https://www.instagram.com/hardiichopra/" className='text-red'>
          <FaInstagram  size={"30px"} />
          </a>
          <a href="https://www.linkedin.com/in/hardik-chopra-648b28233" className='text-blue-400'>
          <FaLinkedin  size={"30px"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SideTopnav;
